import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';
type PathShape = {
  type: 'path';
  d: string;
};
type PolygonShape = {
  type: 'polygon';
  points: string;
};
type WordmarkShape = PathShape | PolygonShape;

/** Exact vector outlines from the original kusminov.com name animation. */
const ALEXANDER: WordmarkShape[] = [{
  type: 'path',
  d: 'M347.7,19.5c1.8-0.7,3.5-1.8,4.7-3.4c1.2-1.7,1.9-3.8,1.8-5.9v0c0.1-2.6-0.8-5-2.6-6.9c-2-2-5-3.1-8.8-3.1H329v30.1h6.6v-9.6h5.2l6.4,9.6h7.7L347.7,19.5z M347.4,10.5c0,1.2-0.4,2.3-1.3,3.1c-1.1,0.8-2.4,1.2-3.8,1.1h-6.7V6.2h6.6c1.4-0.1,2.7,0.3,3.8,1.1C347,8.1,347.5,9.3,347.4,10.5L347.4,10.5L347.4,10.5z'
}, {
  type: 'polygon',
  points: '290.5,30.3 313.4,30.3 313.4,24.4 297.1,24.4 297.1,18.1 311.3,18.1 311.3,12.2 297.1,12.2 297.1,6.1 313.2,6.1 313.2,0.2 290.5,0.2'
}, {
  type: 'path',
  d: 'M274.2,9.3c-0.8-1.8-1.9-3.4-3.3-4.7c-1.5-1.4-3.2-2.4-5.1-3.2c-2.1-0.8-4.3-1.2-6.5-1.1h-11.7v30.1h11.7c2.2,0,4.4-0.4,6.5-1.1c1.9-0.7,3.6-1.8,5.1-3.2c1.4-1.3,2.5-3,3.3-4.8c0.8-1.9,1.2-3.9,1.1-5.9v-0.1C275.4,13.1,275,11.1,274.2,9.3z M268.5,15.3c0,1.2-0.2,2.5-0.7,3.7c-0.4,1.1-1.1,2-1.9,2.8c-0.8,0.8-1.8,1.4-2.9,1.8c-1.2,0.4-2.4,0.7-3.7,0.6h-5.1V6.2h5.1c1.3,0,2.5,0.2,3.7,0.7c1.1,0.4,2,1.1,2.9,1.9c0.8,0.8,1.4,1.8,1.8,2.9C268.3,12.8,268.5,14,268.5,15.3L268.5,15.3L268.5,15.3z'
}, {
  type: 'polygon',
  points: '204.2,30.3 210.7,30.3 210.7,11.2 225.3,30.3 230.9,30.3 230.9,0.2 224.4,0.2 224.4,18.7 210.3,0.2 204.2,0.2'
}, {
  type: 'path',
  d: 'M177.7,0h-6.1l-12.9,30.3h6.7l2.7-6.7h12.7l2.7,6.7h6.9L177.7,0z M170.5,17.7l4-9.8l4,9.8H170.5L170.5,17.7z'
}, {
  type: 'polygon',
  points: '117.4,30.3 124.9,30.3 131.7,20 138.4,30.3 146.1,30.3 135.7,14.9 145.7,0.2 138.2,0.2 131.8,10 125.5,0.2 117.8,0.2 127.8,15'
}, {
  type: 'polygon',
  points: '81.3,30.3 104.2,30.3 104.2,24.4 87.8,24.4 87.8,18.1 102,18.1 102,12.2 87.8,12.2 87.8,6.1 104,6.1 104,0.2 81.3,0.2'
}, {
  type: 'polygon',
  points: '45.9,30.3 67.5,30.3 67.5,24.3 52.5,24.3 52.5,0.2 45.9,0.2'
}, {
  type: 'path',
  d: 'M19.3,0h-6.1L0.4,30.3h6.7l2.7-6.7h12.7l2.7,6.7h6.9L19.3,0z M12.2,17.7l4-9.8l4,9.8H12.2L12.2,17.7z'
}];
const KUSMINOV: WordmarkShape[] = [{
  type: 'polygon',
  points: '285.5,30.7 291.3,30.7 303.4,0.5 296.3,0.5 288.5,21.6 280.7,0.5 273.4,0.5'
}, {
  type: 'path',
  d: 'M261.4,9.4c-0.8-1.8-1.9-3.5-3.3-4.9c-1.4-1.4-3.2-2.5-5-3.3c-4.1-1.6-8.7-1.6-12.8,0c-3.8,1.5-6.8,4.5-8.4,8.3c-0.8,1.9-1.2,3.9-1.1,6v0c0,2.1,0.4,4.1,1.1,6c0.8,1.8,1.9,3.5,3.3,4.9c1.4,1.4,3.2,2.5,5,3.3c4.1,1.6,8.7,1.6,12.8,0v0.1c3.8-1.5,6.8-4.5,8.4-8.3c0.8-1.9,1.2-3.9,1.1-6v-0.1C262.6,13.3,262.2,11.3,261.4,9.4z M255.7,15.5c0,1.2-0.2,2.5-0.7,3.6c-0.4,1.1-1,2.1-1.8,3c-0.8,0.9-1.8,1.6-2.9,2.1c-1.1,0.5-2.4,0.7-3.6,0.7c-1.3,0-2.5-0.2-3.7-0.7l0-0.1c-2.2-1-3.9-2.8-4.7-5c-0.4-1.1-0.7-2.3-0.7-3.5v-0.1c0-1.2,0.2-2.5,0.7-3.6c0.4-1.1,1-2.1,1.8-3c0.8-0.9,1.8-1.5,2.8-2c1.2-0.5,2.4-0.7,3.7-0.7c1.3,0,2.5,0.2,3.6,0.7c2.2,1,3.9,2.8,4.8,5C255.5,13,255.7,14.2,255.7,15.5L255.7,15.5z'
}, {
  type: 'polygon',
  points: '189,30.5 195.5,30.5 195.5,11.4 210,30.5 215.6,30.5 215.6,0.5 209.1,0.5 209.1,18.9 195.1,0.5 189,0.5 189,30.5'
}, {
  type: 'polygon',
  points: '165.6,30.5 172.2,30.5 172.2,0.5 165.6,0.5 165.6,30.5'
}, {
  type: 'polygon',
  points: '118.8,30.5 125.3,30.5 125.3,11 133.7,23.7 133.8,23.7 142.2,10.9 142.2,30.5 148.7,30.5 148.7,0.5 141.7,0.5 133.8,13.2 125.9,0.6 118.8,0.6 118.8,30.5'
}, {
  type: 'path',
  d: 'M97.2,30.3c1.2-0.4,2.4-1,3.4-1.8c1-0.8,1.8-1.8,2.3-2.9c0.6-1.2,0.8-2.6,0.8-4v-0.1c0-1.2-0.2-2.3-0.6-3.4c-0.4-0.9-1.1-1.8-1.8-2.5c-0.9-0.7-1.9-1.3-3-1.8c-1.3-0.5-2.7-1-4.1-1.4c-1.3-0.3-2.4-0.6-3.2-0.9c-0.7-0.2-1.4-0.5-2-0.8c-0.4-0.2-0.8-0.6-1-1c-0.2-0.4-0.3-0.8-0.3-1.3V8.5c0-0.7,0.4-1.4,1-1.9c0.9-0.6,1.9-0.8,2.9-0.7c1.3,0,2.6,0.3,3.9,0.8c1.4,0.6,2.7,1.3,4,2.2l3.4-5c-1.5-1.2-3.2-2.2-5.1-2.8c-1.9-0.7-4-1-6.1-1c-1.4,0-2.9,0.2-4.2,0.6c-1.2,0.4-2.3,1-3.3,1.8c-0.9,0.8-1.6,1.8-2.2,2.8c-0.5,1.2-0.8,2.4-0.8,3.7v0.1c0,1.3,0.2,2.5,0.7,3.7c0.5,1,1.1,1.8,2,2.5c1,0.7,2,1.3,3.1,1.7c1.3,0.5,2.7,0.9,4.1,1.2c1.3,0.3,2.3,0.6,3.1,0.9c0.6,0.2,1.3,0.5,1.8,0.9c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.2,0.7,0.2,1.1v0.1c0,0.8-0.4,1.6-1.1,2.1c-1,0.6-2.1,0.8-3.2,0.7c-1.6,0-3.2-0.3-4.7-1c-1.5-0.7-2.9-1.6-4.2-2.7L80,26.1c1.7,1.6,3.8,2.8,6,3.6c2.2,0.8,4.4,1.2,6.7,1.1C94.3,30.9,95.8,30.7,97.2,30.3'
}, {
  type: 'path',
  d: 'M58.5,30.1c1.6-0.5,3-1.4,4.2-2.5c1.2-1.2,2.1-2.6,2.6-4.2c0.6-1.9,1-3.9,0.9-5.9V0.5h-6.6v17.2c0.1,2-0.5,3.9-1.7,5.4c-1.3,1.2-3,1.9-4.7,1.8c-1.8,0.1-3.5-0.6-4.7-1.9c-1.2-1.6-1.9-3.5-1.7-5.5V0.5h-6.6v17.2c0,4.4,1.1,7.7,3.4,10c2.3,2.2,5.5,3.3,9.5,3.3C54.8,31,56.7,30.7,58.5,30.1'
}, {
  type: 'polygon',
  points: '0,28.1 6.7,21.3 10.1,17.7 19.4,30.5 27.3,30.5 14.5,13.2 26.7,0.5 18.7,0.5 6.7,13.6 6.7,0.5 0,0.5 0,28'
}];
const DRAW_DURATION = 1200;
const FILL_DURATION = 800;
const INITIAL_DELAY = 140;
function VectorShape({
  shape
}: {
  shape: WordmarkShape;
}) {
  return shape.type === 'path' ? <path d={shape.d} data-id="element-345" data-mp="38ck6xda3ha0t" /> : <polygon points={shape.points} data-id="element-346" data-mp="2oo5shkpi1z12" />;
}

/**
 * Exact supplied wordmark vectors with the original Vivus `async` behavior:
 * all paths trace concurrently from blank outlines, then resolve to solid ink.
 */
export function NameSignature() {
  const reduceMotion = useReducedMotion();
  const desktopRef = useRef<SVGSVGElement>(null);
  const mobileRef = useRef<SVGSVGElement>(null);
  useEffect(() => {
    const svgs = [desktopRef.current, mobileRef.current].filter((svg): svg is SVGSVGElement => svg !== null);
    const shapes = svgs.flatMap(svg => Array.from(svg.querySelectorAll<SVGGeometryElement>('path, polygon')));
    if (reduceMotion) {
      shapes.forEach(shape => {
        shape.style.strokeDasharray = 'none';
        shape.style.strokeDashoffset = '0';
        shape.style.fill = '#111111';
        shape.style.fillOpacity = '1';
        shape.style.stroke = '#111111';
      });
      svgs.forEach(svg => {
        svg.style.visibility = 'visible';
      });
      return;
    }
    let cancelled = false;
    const animations: Animation[] = [];

    // Prepare the original geometry offscreen: no fill, full native dash offset.
    shapes.forEach(shape => {
      const length = shape.getTotalLength();
      shape.style.fill = '#111111';
      shape.style.fillOpacity = '0';
      shape.style.stroke = '#111111';
      shape.style.strokeWidth = '0.75';
      shape.style.strokeDasharray = `${length}`;
      shape.style.strokeDashoffset = `${length}`;
    });
    svgs.forEach(svg => {
      svg.style.visibility = 'visible';
    });
    const startTimer = window.setTimeout(() => {
      if (cancelled) return;

      // Original Vivus `async` behavior: every path begins drawing together.
      const drawAnimations = shapes.map(shape => {
        const length = shape.getTotalLength();
        const animation = shape.animate([{
          strokeDashoffset: `${length}`
        }, {
          strokeDashoffset: '0'
        }], {
          duration: DRAW_DURATION,
          easing: 'cubic-bezier(0, 0, 0.58, 1)',
          fill: 'forwards'
        });
        animations.push(animation);
        return animation;
      });
      Promise.all(drawAnimations.map(animation => animation.finished)).then(() => {
        if (cancelled) return;
        // A separate opacity phase makes the solid ink visibly fade over the trace.
        shapes.forEach(shape => {
          animations.push(shape.animate([{
            fillOpacity: 0
          }, {
            fillOpacity: 1
          }], {
            duration: FILL_DURATION,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards'
          }));
        });
      }).catch(() => undefined);
    }, INITIAL_DELAY);
    return () => {
      cancelled = true;
      window.clearTimeout(startTimer);
      animations.forEach(animation => animation.cancel());
    };
  }, [reduceMotion]);
  return <div role="img" aria-label="Alexander Kusminov" className="mx-auto flex w-full max-w-[1120px] justify-center" data-id="element-347" data-mp="27fn28fobdk9j">
      <span className="sr-only" data-id="element-348" data-mp="2cd6fbc99zqzw">Alexander Kusminov</span>

      {/* Desktop: one long, deliberately spaced wordmark. */}
      <svg ref={desktopRef} aria-hidden="true" viewBox="0 -2 705 35" preserveAspectRatio="xMidYMid meet" className="hidden h-auto w-full overflow-visible sm:block" style={{
      visibility: reduceMotion ? 'visible' : 'hidden'
    }} data-id="element-349" data-mp="22h3atzqybg9s">
        <g data-id="element-350" data-mp="2v7v8l1no0cz8">
          {ALEXANDER.map((shape, index) => <VectorShape key={`desktop-alexander-${index}`} shape={shape} data-id="element-351" data-mp="2ggcpuw3f84c6" data-mpi={index} />)}
        </g>
        <g transform="translate(400 0)" data-id="element-352" data-mp="2lewe535hls7p">
          {KUSMINOV.map((shape, index) => <VectorShape key={`desktop-kusminov-${index}`} shape={shape} data-id="element-353" data-mp="394qpfga5r8pu" data-mpi={index} />)}
        </g>
      </svg>

      {/* Mobile: the same original vectors become a clear two-line lockup. */}
      <svg ref={mobileRef} aria-hidden="true" viewBox="0 -2 357 76" preserveAspectRatio="xMidYMid meet" className="block h-auto w-full overflow-visible sm:hidden" style={{
      visibility: reduceMotion ? 'visible' : 'hidden'
    }} data-id="element-354" data-mp="12grlfane33vr">
        <g data-id="element-355" data-mp="177q065sqbtww">
          {ALEXANDER.map((shape, index) => <VectorShape key={`mobile-alexander-${index}`} shape={shape} data-id="element-356" data-mp="17acjt3sw9zvh" data-mpi={index} />)}
        </g>
        <g transform="translate(26 41)" data-id="element-357" data-mp="jkrmtgzwp237">
          {KUSMINOV.map((shape, index) => <VectorShape key={`mobile-kusminov-${index}`} shape={shape} data-id="element-358" data-mp="el5d3hjae3z5" data-mpi={index} />)}
        </g>
      </svg>
    </div>;
}